module.exports = __webpack_public_path__ + "media/Video 113.44283018.mp4";